// settings strings (fr). Machine-drafted — review with a native speaker before launch.
const settings = {
	settings: {
		// Settings sidebar nav
		nav_yourProfile: 'Votre profil',
		nav_billing: 'Facturation',
		nav_generateZapierKey: 'Générer une clé Zapier',
		nav_generateIntegrationKey: "Générer une clé d'intégration",
		nav_mcp: 'Assistants IA (MCP)',
		nav_referEarn: 'Parrainez et gagnez',
		nav_manageWorkspaces: 'Gérer les espaces de travail',
		nav_emailAccounts: 'Comptes de messagerie',
		nav_basicSettings: 'Paramètres de base',
		nav_teamMembers: "Membres de l'équipe",
		nav_previewCard: 'Aperçu de la carte',
		nav_workspaceDomain: "Domaine de l'espace de travail",
		nav_videoCards: 'Cartes vidéo',
		nav_customDomainSettings: 'Paramètres de domaine personnalisé',
		nav_personalization: 'Personnalisation',
		section_accountSettings: 'Paramètres du compte',
		section_workspaceSettings: "Paramètres de l'espace de travail",
		section_whiteLabelSettings: 'Paramètres de marque blanche',

		// Shared dialog titles / statuses
		title_success: 'Succès',
		title_error: 'Erreur',
		title_oops: 'Oups !',
		title_warning: 'Avertissement',
		title_sorry: 'Désolé',
		uploading: 'Téléversement...',

		// Basic Settings
		basicDetailsTitle: 'Détails de base',
		workspaceImageUpdated: "L'image de l'espace de travail a été mise à jour.",
		workspaceName: "Nom de l'espace de travail",
		timeZone: 'Fuseau horaire',
		saveUpdate: 'Enregistrer et mettre à jour',
		noWorkspace: "Vous n'avez actuellement aucun espace de travail",
		nothingToUpdate: 'Rien à mettre à jour.',
		changesSaved: 'Vos modifications ont été enregistrées avec succès',
		somethingWrongSaving: "Une erreur s'est produite lors de l'enregistrement de vos modifications.",

		// Custom Domain Settings
		domainTitle: 'Domaine',
		addCustomDomain: 'Ajoutez votre domaine personnalisé',
		whiteLabelRunDesc: "C'est ici que votre application en marque blanche sera exécutée",
		howToSetupWhiteLabel: 'Comment configurer votre domaine en marque blanche ?',
		domainName: 'Nom de domaine',
		domainPlaceholder: 'app.exemple.io',
		saveDomain: 'Enregistrer le domaine',
		cnameInstructions:
			"Pour associer un domaine personnalisé à votre portail d'assistance, assurez-vous d'avoir ajouté l'enregistrement CNAME suivant dans les paramètres de votre éditeur de zone DNS. Votre webmaster ou administrateur serveur devrait pouvoir vous aider à le configurer.",
		tableType: 'Type',
		tableKey: 'Clé',
		tableValue: 'Valeur',
		tableSslStatus: 'Statut SSL',
		tableConnectionStatus: 'Statut de connexion',
		statusActive: 'actif',
		statusInactive: 'inactif',
		copy: 'copier',
		cannotSaveHostDomain: "Impossible d'enregistrer des domaines hôtes en tant que domaine de marque blanche",

		// Manage Workspaces
		workspacesTitle: 'Espaces de travail',
		addNewWorkspace: 'Ajouter un nouvel espace de travail',
		searchWorkspaces: 'Rechercher des espaces de travail',
		howToAddWorkspaces: 'Comment ajouter de nouveaux espaces de travail à votre compte ?',
		noWorkspacesToShow: 'Aucun espace de travail à afficher.',
		maxLimitReached: 'Limite maximale atteinte',
		maxWorkspaceLimit: "Vous avez atteint la limite maximale d'espaces de travail pour ce forfait",
		problemGettingWorkspaces: "Un problème est survenu lors de la récupération de vos espaces de travail",

		// Invite member (workspace flow)
		inviteMemberTitle: 'Inviter un membre',
		workspaceDetails: "Détails de l'espace de travail",
		inviteTeamMembers: "Inviter des membres de l'équipe",
		inviteTeamMembersStep: "Inviter des membres de l'équipe",
		addMoreMembersLater:
			"Vous pouvez toujours ajouter d'autres membres de l'équipe plus tard depuis les paramètres de l'espace de travail.",

		// New workspace detail
		newWorkspace: 'Nouvel espace de travail',
		howToAddWorkspacesAccount: 'Comment ajouter de nouveaux espaces de travail à votre compte.',
		workspaceNamePlaceholder: "Le nom de votre espace de travail",
		saveNext: 'Enregistrer et continuer',

		// Workspace card
		selected: 'sélectionné',
		createdOn: 'Créé le :',
		remove: 'Supprimer',
		removeWorkspaceConfirm: "Voulez-vous vraiment supprimer l'espace de travail ?",
		cannotDeleteCurrent:
			"Impossible de supprimer l'espace de travail sélectionné. Passez à un autre espace de travail, puis supprimez-le.",

		// Profile / Account
		accountTitle: 'Compte',
		deleteAccount: 'Supprimer le compte',
		deleteAccountDesc:
			'Supprimer votre compte supprimera votre accès et toutes vos informations sur ce site. Voulez-vous vraiment continuer ?',
		updatedProfileSuccess: 'Profil mis à jour avec succès',
		accountDeletionTitle: 'Suppression du compte',
		deleteAccountConfirm: 'Voulez-vous supprimer votre compte ?',
		btnNo: 'Non',
		btnYes: 'Oui',
		accountDeletedTitle: 'Compte supprimé',
		accountDeletedText: 'Votre compte a été supprimé avec succès.',
		accountDeletionRelogin:
			'Si vous souhaitez supprimer votre compte, veuillez vous reconnecter, puis supprimer votre compte.',

		// Basic profile fields
		firstName: 'Prénom',
		lastName: 'Nom',
		email: 'E-mail',
		emailCannotChange: "L'e-mail ne peut pas être modifié",

		// Change password
		currentPassword: 'Mot de passe actuel',
		invalidPassword: 'Mot de passe non valide',
		newPassCannotSame: 'Le nouveau mot de passe ne peut pas être identique',
		confirmPassMismatch: 'La confirmation du mot de passe ne correspond pas',

		// Team members
		membersTitle: 'Membres',
		inviteMemberBtn: 'Inviter un membre',
		howToInviteMember: "Comment inviter un membre de l'équipe dans votre espace de travail ?",
		noTeamMembers: "Il n'y a actuellement aucun membre d'équipe dans cet espace de travail.",
		errorDeletingMember: "Une erreur s'est produite lors de la suppression du membre",
		deleteMemberConfirm: 'Voulez-vous vraiment supprimer le membre ?',
		invitationLinkGenerated: "Un lien d'invitation a été généré pour %{email}",
		invitationLinkSent: "Un lien d'invitation a été envoyé à %{email}",
		maxMembersReached: 'Vous avez atteint le nombre maximal de membres pour votre forfait',

		// Members card
		searchByNameEmail: 'Rechercher par nom et e-mail',
		inviteLinkCopied: "Lien d'invitation copié.",
		noSearchResults: 'Aucun résultat trouvé.',

		// Members table
		colName: 'Nom',
		colRole: 'Rôle',
		colStatus: 'Statut',
		colActions: 'Actions',
		roleManager: 'Gestionnaire',
		roleMember: 'Membre',
		roleNotFound: 'Rôle introuvable',
		tooltipEditRole: 'Modifier le rôle',
		tooltipDeleteMember: "Supprimer le membre de l'équipe",
		tooltipCopyInviteLink: "Copier le lien d'invitation.",

		// Invite member modal
		howToInviteWorkspace: "Comment inviter un membre de l'équipe dans l'espace de travail ?",
		placeholderFirstName: 'jean',
		placeholderLastName: 'dupont',
		placeholderEmailExample: 'jeandupont@exemple.com',
		sendInvitation: "Envoyer l'invitation",
		ownerCannotInvite: "Le propriétaire ne peut pas s'inviter lui-même dans l'espace de travail.",
		memberEmailExists: 'Un membre avec cet e-mail existe déjà.',

		// Referral
		referAndEarn: 'Parrainez et gagnez',
		earnCommission: 'Gagnez 30 % de commissions récurrentes !',
		howItWorks: "Voici comment fonctionne notre programme d'affiliation :",
		step1Join: '1. Rejoignez',
		step2Refer: '2. Parrainez',
		step3Earn: '3. Gagnez',
		joinDesc: "Inscrivez-vous au programme d'affiliation CardClan.",
		referDesc: "Partagez votre lien d'affiliation unique avec vos amis et abonnés.",
		earnDesc: "Recevez 30 % de commission sur chaque vente que nous réalisons grâce à votre lien d'affiliation.",
		noteLabel: 'Remarque : ',
		noteText:
			"Ce n'est pas seulement ce paiement unique lors de leur inscription. Cette commission de 30 % vous sera versée chaque mois tant que leur compte CardClan est actif.",
		becomeAffiliate: 'Devenir affilié',
		createPromoter: 'Créer un promoteur',
		registerAffiliateDesc:
			"Utilisez le lien ci-dessous pour vous inscrire en tant qu'affilié CardClan et commencer à promouvoir.",
		createPromoterLink: 'Créer un promoteur',

		// Dropdown
		options: 'Options',

		// AI Assistants (MCP)
		mcp_title: 'Assistants IA (MCP)',
		mcp_description: 'Connectez Claude, Cursor, VS Code ou tout assistant compatible MCP à CardClan. Votre assistant pourra trouver des cartes, les envoyer ou les programmer, organiser les dossiers et suivre l’engagement, avec votre compte et les limites de votre forfait.',
		mcp_keyTitle: 'Votre clé API',
		mcp_keyDescription: 'L’assistant s’authentifie avec votre clé API CardClan (la même que pour les intégrations).',
		mcp_keyWarning: 'Toute personne disposant de cette clé peut envoyer des cartes depuis votre compte. Gardez-la secrète et ne la collez jamais dans un document partagé.',
		mcp_generateKey: 'Générer une clé API',
		mcp_show: 'Afficher',
		mcp_hide: 'Masquer',
		mcp_copy: 'Copier',
		mcp_copied: 'Copié dans le presse-papiers',
		mcp_urlTitle: 'URL du serveur',
		mcp_urlDescription: 'Le point de terminaison MCP de CardClan (Streamable HTTP).',
		mcp_setupTitle: 'Ajouter CardClan à votre assistant',
		mcp_setupDescription: 'Choisissez votre client et copiez la configuration. Le texte copié contient votre clé API complète.',
		mcp_clientOther: 'Autres clients',
		mcp_hint_claudeCode: 'Exécutez cette commande dans votre terminal.',
		mcp_hint_claudeDesktop: 'Ouvrez Réglages → Développeur → Modifier la configuration, fusionnez ceci dans claude_desktop_config.json puis redémarrez Claude Desktop. Nécessite Node.js.',
		mcp_hint_cursor: 'Ajoutez ceci à ~/.cursor/mcp.json (ou .cursor/mcp.json dans un projet).',
		mcp_hint_vscode: 'Ajoutez ceci à .vscode/mcp.json dans votre espace de travail, ou lancez « MCP: Add Server » depuis la palette de commandes.',
		mcp_hint_other: 'Tout client prenant en charge les serveurs MCP distants en Streamable HTTP avec un en-tête personnalisé fonctionnera.',
		mcp_tryPrompt: 'Essayez : « Liste mes cartes CardClan et envoie la carte de fêtes à ann@example.com demain à 9 h. » Votre assistant prévisualisera l’envoi et vous demandera avant d’envoyer un e-mail.',
		mcp_toolsTitle: 'Ce que votre assistant peut faire',
		mcp_toolsDescription: 'Les outils marqués « Peut modifier » changent votre compte ou envoient des e-mails ; la plupart des assistants demandent votre accord avant de les utiliser.',
		mcp_readOnly: 'Lecture seule',
		mcp_makesChanges: 'Peut modifier',
		mcp_activityTitle: 'Activité récente',
		mcp_activityDescription: 'Chaque action effectuée via MCP avec votre clé API. Conservée 90 jours.',
		mcp_activityTotal: '%{count} actions au cours des 90 derniers jours',
		mcp_activityEmpty: 'Aucune activité pour l’instant. Une fois votre assistant connecté, ses actions apparaîtront ici.',
		mcp_activityLoadFailed: 'Impossible de charger l’activité MCP.',
		mcp_refresh: 'Actualiser',
		mcp_loadMore: 'Charger plus',
		mcp_colTime: 'Heure',
		mcp_colTool: 'Action',
		mcp_colResult: 'Résultat',
		mcp_colDuration: 'Durée',
		mcp_success: 'Réussi',
		mcp_failed: 'Échec',
	} as Record<string, string>,
};
export default settings;
